// extracted by mini-css-extract-plugin
export var collapsedSummary = "_pd-0";